document.addEventListener("DOMContentLoaded", function() {
  initAffiliateTracking();
  setupFormHandlers();
});

function initAffiliateTracking() {
  const urlParams = new URLSearchParams(window.location.search);
  const memberId = urlParams.get('memberId');
  const platform = urlParams.get('shortPlatform');

  if (memberId) localStorage.setItem('affiliate_memberId', memberId);
  if (platform) localStorage.setItem('affiliate_platform', platform);

  updateProductLinks();

  new MutationObserver(updateProductLinks).observe(document.body, {
    childList: true,
    subtree: true
  });
}

function updateProductLinks() {
  const memberId = localStorage.getItem('affiliate_memberId');
  const platform = localStorage.getItem('affiliate_platform');

  document.querySelectorAll(`
    a[href*="/products/"],
    a[href*="${window.location.host}/products/"]
  `).forEach(link => {
    const url = new URL(link.href);
    if (memberId) url.searchParams.set('memberId', memberId);
    if (platform) url.searchParams.set('shortPlatform', platform);
    link.href = url.toString();
  });
}

function setupFormHandlers() {
  injectAffiliateFields();
  document.querySelectorAll('form[action="/cart"], form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', () => {
      localStorage.removeItem('affiliate_memberId');
      localStorage.removeItem('affiliate_platform');
    });
  });

  if (isThankYouPage()) {
    localStorage.clear();
  }
}

function injectAffiliateFields() {
  const forms = document.querySelectorAll(`
    form[action="/cart"],
    form[action="/cart/add"],
    form[action*="/checkouts"]
  `);

  const memberId = localStorage.getItem('affiliate_memberId');
  const platform = localStorage.getItem('affiliate_platform');

  forms.forEach(form => {
    if (memberId && !form.querySelector('[name="attributes[memberId]"]')) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'attributes[memberId]';
      input.value = memberId;
      form.appendChild(input);
    }

    if (platform && !form.querySelector('[name="attributes[shortPlatform]"]')) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'attributes[shortPlatform]';
      input.value = platform;
      form.appendChild(input);
    }
  });
}

function isThankYouPage() {
  return /(\/thank_you|\/checkouts.*thank_you)/.test(window.location.pathname + window.location.search);
}
